import styled from 'styled-components';

export const UserEvaluationLink = styled.strong`
  color: ${(props) => props.theme.colors.blue6}!important;
  text-decoration: underline;
`;

export const UserEvaluationStrong = styled.strong`
  color: ${(props) => props.theme.colors.grayDark3};
`;

export const UserEvaluationTitle = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${(props) => props.theme.colors.grayDark3};
  }

  h4 {
    margin-bottom: 1rem;
  }
`;

export const UserEvaluationContainer = styled.article`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
  justify-content: center;
  height: 100vh;

  .item {
    font-size: 14px;
  }

  p.item {
    margin-bottom: 0;
  }

  p.last {
    margin-bottom: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 0 1rem;

    p.last {
      margin: 1rem 0 1rem 0;
    }
  }
`;

export const UserEvaluationBox = styled.div`
  max-width: 37.125rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
`;

export const UserEvaluationRow = styled.div`
  width: 100%;
  max-width: 800px;

  .content {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
`;

export const UserEvaluationRowWithColumn = styled.footer`
  display: flex;
  gap: 1.5rem;
  margin-bottom: 0.25rem;

  & > div {
    flex: 1;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    gap: 1rem;

    & > div {
      width: 100%;
    }
  }
`;
